import { render, staticRenderFns } from "./App.vue?vue&type=template&id=c4a11b52&scoped=true&"
import script from "./app.js?vue&type=script&lang=js&"
export * from "./app.js?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=c4a11b52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a11b52",
  null
  
)

export default component.exports